import React, { useState } from 'react';
import TextComponent from '~/components/reusable/TextComponent';
import { getSettingsClass } from '~/utils/helpers';
import { useViewport } from '~/utils/viewport-provider';

export interface Props {
  block: {
    _template: string;
    settings: Settings;
    css_class_name: string;
    section_background: string;
    content_background: string;
    container_height: number;
    border_radius: number;
    reverse_option: ReusableReverseContentOrderField;
    container_padding: ReusableContainerPadding;
    container_gap: number;
    content_alignment: React.CSSProperties['textAlign'];
    name_text: ReusableTextField;
    title_text: ReusableTextField;
    quote_text: ReusableTextField;
    reusable_image_field: ReusableImageFieldProp;
  };
}

const TestimonialsV2 = ({ block }: Props) => {
  const settingsClass = getSettingsClass(block.settings);
  const { isMobile, isDesktop } = useViewport();

  const {
    reusable_image_field: image,
    title_text,
    name_text,
    quote_text,
    border_radius,
    section_background,
    content_background,
    content_alignment,
    container_height,
    reverse_option,
    container_gap,
    container_padding,
  } = block;

  return (
    <section
      className={`block__testimonials block ${block.css_class_name} ${settingsClass}`}
      style={{
        background: section_background ?? '',
      }}
    >
      <div className='container'>
        <div
          className={`flex flex-wrap ${reverse_option.reverse_desktop ? 'flex-row-reverse' : ''} ${reverse_option.reverse_mobile ? 'flex-wrap-reverse' : ''} justify-center`}
          style={{
            gap: container_gap ? `${container_gap}rem` : '',
          }}
        >
          {image?.src && (!isMobile || !image?.hide_image_on_mobile) && (
            <img
              src={image.src}
              alt={image.alt}
              title={image.alt}
              className='self-center'
              style={{
                borderRadius: border_radius ? `${border_radius}rem` : '',
                translate: `${image?.offset?.horizontal ?? 0}rem ${image?.offset?.vertical ?? 0}rem`,
                scale: `${image?.scale?.x ?? 1} ${image?.scale?.y ?? 1}`,
                width:
                  (image?.responsive_width?.mobile && isMobile) ||
                  (image?.responsive_width?.desktop && !isMobile)
                    ? `${isMobile ? image?.responsive_width?.mobile : image?.responsive_width?.desktop}${image?.responsive_width?.unit || 'rem'}`
                    : 'auto',
              }}
            />
          )}
          <div
            className='col-lg-8 col-12 flex flex-col justify-center'
            style={{
              borderRadius: border_radius ? `${border_radius}rem` : '',
              backgroundColor: content_background ?? '',
              height:
                container_height && !isMobile ? `${container_height}rem` : '',
              textAlign: content_alignment || 'left',
              paddingLeft:
                container_padding?.left && isDesktop
                  ? `${container_padding.left}rem`
                  : '30px',
              paddingRight:
                container_padding?.right && isDesktop
                  ? `${container_padding.right}rem`
                  : '30px',
            }}
          >
            {name_text && <TextComponent data={name_text} />}
            {title_text && (
              <TextComponent
                data={title_text}
                as='h3'
              />
            )}
            {quote_text && <TextComponent data={quote_text} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsV2;
